import { IconTypes } from '@stockmarkteam/donguri-ui';
import type { InsightAxisType } from '@/types/insights';

export type InsightAxisPresentation = {
  label: string;
  icon: IconTypes;
  description: string;
  subject: string;
};

export const insightAxisPresentations: Record<
  InsightAxisType,
  InsightAxisPresentation
> = {
  personal: {
    label: 'あなたの関心から',
    subject: 'あなたの関心',
    icon: 'your-tips',
    description:
      'あなたが読んでいるパーソナルニュースや、お気に入りテーマの記事から選んだトピックです。日頃追いかけている分野の、新しい動きが分かります。',
  },
  organization: {
    label: '組織の関心から',
    subject: '組織の関心',
    icon: 'member-tips',
    description:
      'あなたの組織で注目されている記事から選んだトピックです。組織がいま何に注目しているのかが分かります。',
  },
  outside: {
    label: '関心の外から',
    subject: '関心の外',
    icon: 'out-tips',
    description:
      '登録した業務情報をもとに、普段は目にしない分野から選んだトピックです。自分の専門の外で起きている動きが分かります。',
  },
};

export const INSIGHT_HINT_TITLE = '発想のヒント';

export const resolveInsightAxisErrorTitle = (axis: InsightAxisType): string =>
  `${insightAxisPresentations[axis].subject}に関するトピックと、その発想のヒントの生成に失敗しました`;
